import React from 'react';

import css from './SectionFrame.module.css';

/**
 * SectionFrame — shared content width + horizontal padding wrapper.
 *
 * Used inside every Wheelplace section to cap content at
 * `--contentMaxWidth` (1464px) and apply the canonical horizontal
 * padding (`--containerPaddingMobile` / `--containerPaddingDesktop`).
 *
 * This is a pure layout primitive — no background, no vertical
 * padding, no typography. The outer <section> (or whatever) controls
 * background band and vertical rhythm; this just handles the inner
 * content column so every page lines up on the same gutters.
 *
 * API:
 *   - as:      element tag, defaults to 'div'. Use 'section' when the
 *              frame is the whole section (common on Om page).
 *   - width:   'default' (1464, uses the content-max token) | 'narrow'
 *              (780, reading width for prose / pull-quotes). Defaults
 *              to 'default'.
 *   - className: forwarded as an additional class for per-use tweaks.
 */

const SectionFrame = ({
  as: Tag = 'div',
  width = 'default',
  className,
  children,
  ...rest
}) => {
  const widthClass = width === 'narrow' ? css.narrow : css.default;
  const classes = [css.root, widthClass, className].filter(Boolean).join(' ');

  return (
    <Tag className={classes} {...rest}>
      {children}
    </Tag>
  );
};

export default SectionFrame;
